import { render, staticRenderFns } from "./SpotsPublishModal.vue?vue&type=template&id=cf3b8822&"
import script from "./SpotsPublishModal.vue?vue&type=script&lang=js&"
export * from "./SpotsPublishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports